import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Footer.css';

function Footer() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <footer className="site-footer" ref={ref}>
      <motion.div
        className="footer-divider"
        initial={{ scaleX: 0 }}
        animate={inView ? { scaleX: 1 } : {}}
        transition={{ duration: 1, ease: [0.77, 0, 0.175, 1] }}
      />
      <div className="footer-inner">
        <motion.div
          className="footer-left"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <img src="/logo-official.png" alt="Casa Primas" className="footer-logo-img" />
        </motion.div>
        <motion.div
          className="footer-center"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.35 }}
        >
          <Link to="/">Home</Link>
          <a href="mailto:hello@casaprimas.com">Contact</a>
          <a href="/privacy.html">Privacy</a>
          <a href="/terms.html">Terms</a>
        </motion.div>
        <motion.div
          className="footer-right"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
        >
          <p>&copy; {new Date().getFullYear()} Casa Primas</p>
          <p>Interior Design &amp; Home Organization</p>
        </motion.div>
      </div>
    </footer>
  );
}

export default Footer;
